export default __webpack_public_path__ + "static/media/social-media.b10848e7.png";